<template>
  <div>
    <wc-data-box
      :title='$store.state.icons.dataBox.details.title'
      :titleIcon='$store.state.icons.dataBox.details.icon'
      :titleIconColor='$store.state.icons.dataBox.details.iconColor'
      :showEdit='!estimate.is_sold'
      @edit='openEdit'
    >
      <wc-two-column-table :items='tableData'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='$store.state.icons.dataBox.details.title'
      :icon='$store.state.icons.dataBox.details.icon'
      :iconColor='$store.state.icons.dataBox.details.iconColor'
      @cancel='cancelEdit'
      @save='saveEdit'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          v-model='estimateDetailCopy.controller_location'
          label='Controller installed in'
        ></v-text-field>
      <template v-if='estimate.is_comm === false'>
        <v-text-field
          label='Stack comes out on'
          dense
          v-model='estimateDetailCopy.mechanical_side'
        ></v-text-field>
      </template>
        <v-select
          :items='optionalOptions'
          dense
          v-model='estimateDetailCopy.mechanical_work'
          label='Mechanical work included?'>
        ></v-select>
        <v-select
          :items='optionalOptions'
          dense
          v-model='estimateDetailCopy.full_automation'
          label='Full automation included?'>
        ></v-select>
        <v-select
          :items='optionalOptions'
          dense
          v-model='estimateDetailCopy.charged_tap'
          label='Charged line for hose bib?'>
        ></v-select>
        <v-select
          :items='optionalOptions'
          dense
          v-model='estimateDetailCopy.charged_feature'
          label='Charged line for water feature?'>
        </v-select>
        <v-checkbox
          :hint="estimate.is_comm ? 'Commercial systems cannot have BM8' : ''"
          :persistent-hint='estimate.is_comm'
          :readonly='estimate.is_comm'
          :disabled='estimate.is_comm'
          v-model='estimateDetailCopy.can_have_bm8'
          label='Can this system have BM8/ES10 option?'>
        </v-checkbox>
        <v-checkbox
          hide-details
          v-model='estimateCopy.install_contact_gets_install_invoice'
          label='Does the install contact get the install invoice?'>
        </v-checkbox>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'

export default {
  name: 'irrigation-estimate-details',
  mixins: [formRules],
  props: {
    estimate: {
      required: true
    },
    estimateDetail: {
      required: true
    }
  },
  data: () => ({
    isFormValid: false,
    showDialog: false,
    label: 'grey--text',
    estimateCopy: {},
    estimateDetailCopy: {}
  }),
  computed: {
    tableData () {
      let data = [
        { text: 'Controller installed in', value: this.estimateDetail.controller_location }
      ]

      if(!this.estimate.is_comm){
        data = [
        ...data,
        { text: 'Stack comes out on:', value: this.estimateDetail.mechanical_side}
        ]
      }

      data = [
        ...data,
        { text: 'Mechanical work included?:', value: this.getOptionalDisplay(this.estimateDetail.mechanical_work) },
        { text: 'Full automation included?:', value: this.getOptionalDisplay(this.estimateDetail.full_automation) },
{ text: 'Can system have BM8/ES10 option?:', value: this.$options.filters.trueFalse(this.estimateDetail.can_have_bm8) },
        { text: 'Install contact gets install invoice?', value: this.$options.filters.trueFalse(this.estimate.install_contact_gets_install_invoice) }
      ]

      return data;
    },
    stackComesOut () {
      return this.$store.state.misc.globalOptions.estimateStackOptions
    },
    optionalOptions () {
      return this.$store.state.misc.globalOptions.estimateOptionals
    }
  },
  methods: {
    openEdit () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.estimateDetailCopy = _.cloneDeep(this.estimateDetail)
      this.showDialog = true
    },
    cancelEdit () {
      this.showDialog = false
    },
    saveEdit () {
      // We're assuming this is an irrigation estimate
      if (this.estimateCopy.is_comm) {
        this.estimateCopy.estimate_detail.can_have_bm8 = false
      }
      this.$emit('update', this.estimateCopy)
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.cancelEdit()
    },
    getSideDisplay (val) {
      if (this.stackComesOut.find(o => o.value === val) !== undefined) {
        return this.stackComesOut.find(o => o.value === val).text
      }
      return ''
    },
    getOptionalDisplay (val) {
      if (this.optionalOptions.find(o => o.value === val) !== undefined) {
        return this.optionalOptions.find(o => o.value === val).text
      }
      return ''
    }
  },
  components: {

  }
}
</script>
